import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let StockChartAxesDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-stockchart-axes';
        }
    }
});
export const StockChartAxesPlugin = {
    name: 'e-stockchart-axes',
    install(Vue) {
        Vue.component(StockChartAxesPlugin.name, StockChartAxesDirective);
    }
};
export let StockChartAxisDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-stockchart-axis';
        }
    }
});
export const StockChartAxisPlugin = {
    name: 'e-stockchart-axis',
    install(Vue) {
        Vue.component(StockChartAxisPlugin.name, StockChartAxisDirective);
    }
};
